module.exports = __webpack_public_path__ + "static/media/mainimg-09.9d81fbf1.png";